import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SaveTheDate from "@/pages/SaveTheDate";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SaveTheDate />} />
          <Route path="/save-the-date" element={<SaveTheDate />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
